import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import DocumentDownload from "../../Entity/DocumentDownload";
import getRemoveCompleteDownload from "../../DependencyInjection/removeCompleteDownload";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";

const eventDispatcher = getEventDispatcher();

const CancelDownloadListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);

    await eventDispatcher.dispatch('CancelDownloadAction', document.getId());
    getRemoveCompleteDownload().remove(document);
    await eventDispatcher.dispatch('ElectronRemoveFile', document.export());
}

export default CancelDownloadListener;